import {SET_SELECTED_VNC, SET_SELECTED_VPS} from "../constants/Vps";

const initState = {
    vps: {},
    vnc: {}
}

const vps = (state = initState, action) => {
    switch (action.type) {
        case SET_SELECTED_VPS:
            return {
                ...state,
                vps: action.payload,
            }
        case SET_SELECTED_VNC:
            return {
                ...state,
                vnc: action.payload,
            }
        default:
            return state;
    }
}

export default vps